<template>
  <div>
    <aside class="ist-leftmenu">
      <div class="ist-list-group">
        <nav class="ist-list">
          <div class="ist-list-item" style="height: 65px">
            <label for="istmenutoggle" class="ist-menu-label ist-menu-appname">{{ appName }}</label>
            <label for="istmenutoggle" id="d">
              <i class="material-icons notranslate">menu</i>
            </label>
          </div>
        </nav>
        <nav class="ist-list menuScrollbar">
          <div v-for="(item, index) in sortedEntries()" :key="index">
            <div>
              <div
                v-bind:class="{
                  row: item.menuEntries
                }"
              >
                <div
                  v-if="item.entryPointUrl === ''"
                  class="ist-list-item menuEntry clickable"
                  @click="item.expand = !item.expand"
                >
                  <span
                    @click="closeExpanded"
                    :class="'mdi ' + item.iconName"
                    class="notranslate clickable"
                    aria-hidden="true"
                    :title="item.title"
                  ></span>

                  <label
                    class="ist-menu-label clickable"
                    v-bind:class="isLink(item.entryPointUrl)"
                    >{{ item.title }}</label
                  >
                </div>
                <router-link
                  v-if="item.entryPointUrl !== ''"
                  class="ist-list-item menuEntry"
                  v-bind:class="isPath(item.entryPointUrl)"
                  :to="item.entryPointUrl"
                >
                  <span
                    @click="closeExpanded"
                    :class="'mdi ' + item.iconName"
                    class="notranslate"
                    aria-hidden="true"
                    :title="item.title"
                  >
                  </span>
                  <label
                    @click="closeExpanded"
                    class="ist-menu-label"
                    v-bind:class="isLink(item.entryPointUrl)"
                    >{{ item.title }}</label
                  >
                  <q-icon
                    v-if="item.showWarning"
                    size="xs"
                    name="mdi-alert-circle"
                    class="warningIcon"
                  >
                  </q-icon>
                </router-link>
                <div v-if="item.menuEntries" class="ist-list-item hideOnMenuClosed clickable">
                  <span
                    @click="item.expand = !item.expand"
                    v-bind:class="{
                      'mdi mdi-chevron-up': item.expand,
                      'mdi mdi-chevron-down': !item.expand
                    }"
                  ></span>
                </div>
              </div>
            </div>

            <nav class="ist-list deep" v-show="item.expand">
              <router-link
                v-for="(subItem, index) in item.menuEntries"
                :key="index"
                custom
                v-slot="{ navigate }"
                :to="subItem.entryPointUrl"
              >
                <div
                  @click="navigate"
                  class="ist-list-item"
                  v-bind:class="isPath(subItem.entryPointUrl)"
                  role="link"
                >
                  <span
                    :class="'mdi ' + subItem.iconName"
                    class="notranslate"
                    aria-hidden="true"
                    :title="subItem.title"
                  ></span>

                  <label class="ist-menu-label clickable">{{ subItem.title }}</label>
                </div>
              </router-link>
            </nav>
          </div>
        </nav>
      </div>

      <div class="ist-list-footer">
        <nav class="ist-list">
          <div class="ist-list-item motto" id="istlogo">
            <img :title="'version:' + buildversion" src="../assets/logo_small.png" />
            <span id="istEveryday" class="hideOnMenuClosed"> <br />Everyday</span>
          </div>
        </nav>
      </div>
    </aside>

    <q-tabs id="page_hotbar">
      <q-route-tab
        v-for="(item, index) in sortedEntries()"
        :key="index"
        :icon="getIcon(item)"
        :to="getUrl(item)"
        :alert="item.showWarning"
        :alert-icon="item.showWarning ? 'mdi-alert-circle' : ''"
        @keyup.enter="openUrl(item)"
        class="ist-layout-left-menu"
      />
    </q-tabs>
  </div>
</template>

<script lang="ts">
import { Vue, Prop } from "vue-property-decorator";
import { useRouter } from "vue-router";

export type menutype = {
  title: string;
  priority: number | null;
  isExternalEntryPoint: boolean;
  entryPointUrl: string;
  count: number;
  iconName: string;
  iconMdiName: string;
  menuEntries: menutype[];
  expand: boolean;
  showWarning: boolean;
};

export default class App extends Vue {
  @Prop({ default: "" })
  appName!: string;
  @Prop({ default: 767 })
  breakpoint!: number;
  @Prop({ default: [] })
  menu!: menutype[];
  @Prop({ default: false })
  overlay!: boolean;
  @Prop()
  urlpath!: string;
  @Prop()
  buildversion!: string;

  miniState = true;
  miniStateHover = false;
  drawer = true;
  router = useRouter();

  /* TODO: Overlay is currently not sufficiently supported in quasar to work as intended */
  isMini(): boolean {
    if (this.overlay) {
      return this.miniStateHover;
    } else {
      return this.miniState;
    }
  }

  sortedEntries(): menutype[] {
    // NB: slice() creates a copy without mutating the original menu array prop
    return this.menu.slice().sort((a: menutype, b: menutype) => {
      // Entries with a null priority wins sort, so let's give them a high default
      if (!a.priority) {
        a.priority = 100;
      }
      if (!b.priority) {
        b.priority = 100;
      }
      if (a.priority > b.priority) {
        return 1;
      } else if (a.priority < b.priority) {
        return -1;
      } else {
        return 0;
      }
    });
  }

  created() {
    if (window.innerWidth < 850) {
      this.miniState = true;
    } else if (window.innerWidth > 850) {
      this.miniState = false;
    }

    window.addEventListener("resize", () => {
      // Give iOS extra time to complete flip animation...
      // TODO: Add debounce
      setTimeout(() => {
        if (window.innerWidth < 850) {
          this.miniState = true;
        } else if (window.innerWidth > 850) {
          this.miniState = false;
        }
      }, 300);
    });
  }

  navigateToPage(item: menutype) {
    this.router.push(item.entryPointUrl);
  }

  openUrl(item) {
    if (item.isExternalEntryPoint) {
      window.open(item.entryPointUrl);
    }
  }

  onUrlPath(NewUrlpath: string) {
    this.urlpath = (NewUrlpath + "#").substr(0, (NewUrlpath + "#").indexOf("#"));
  }

  isPath(aPath) {
    if (aPath == this.urlpath) {
      return "ist-list-item--selected pointer";
    } else if (aPath !== "") {
      return "pointer";
    }
  }

  isLink(aPath) {
    if (aPath !== "") {
      return "pointer";
    }
  }

  getUrl(item) {
    if (item.isExternalEntryPoint) {
      return "/";
    } else {
      return item.entryPointUrl;
    }
  }
  getIcon(item) {
    if (item.isExternalEntryPoint) {
      return "launch";
    } else {
      return item.iconName;
    }
  }

  closeExpanded() {
    this.menu.forEach((m) => {
      m.expand = false;
    });
  }
}
</script>

<style scoped lang="scss">
@import "../assets/variables";
@media only screen and (min-height: 830px) {
  .menuScrollbar {
    max-height: calc(100vh - 150px);
    overflow: auto;
  }
}
@media only screen and (max-height: 829px) {
  .menuScrollbar {
    max-height: calc(100vh - 50px);
    overflow: auto;
  }
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
::-webkit-scrollbar-thumb {
  background: #e1e1e1;
  border: 0px none #ffffff;
  border-radius: 50px;
}
::-webkit-scrollbar-thumb:active {
  background: rgb(1 106 131);
}
::-webkit-scrollbar-track {
  border: 0px none #ffffff;
  border-radius: 50px;
}
::-webkit-scrollbar-corner {
  background: transparent;
}

.mdi {
  width: 1.3em;
  font-size: 26px;
}
aside {
  transition: width 300ms cubic-bezier(0.17, 0.04, 0.03, 0.94);
}

#d {
  transition: all 500ms ease;
  text-align: right;
  font-size: 28px;
}

#menu-title {
  color: $ist-white;
  font-family: "Libre Franklin", sans-serif;
  font-size: 20px;
}

#expanded-menu-entries {
  min-height: calc(100vh - 200px);
  padding: 0;
}

#mini-menu-entries {
  min-height: calc(100vh - 100px);
  padding: 0;
}

.q-chip {
  background: $ist-blue-dark;
  color: white;
}

.flipped-image {
  transform: scaleX(-1);
  right: 0;
  left: inherit !important;
}

.expander-icon {
  padding: 30px 18px 30px 25px;
  cursor: pointer;
  border: 2px solid transparent;
  outline: none;
  height: 85px;
  width: 85px;
  float: right;
}

.external-link-icon {
  color: $ist-blue-x-light;
}

.expander-icon:hover {
  background: $ist-blue-dark;
}
.expander-icon:focus {
  border: 3px solid $ist-blue-x-light;
}

//hack to overwrite css `.q-item:focus{background:hsla(0,0%,74.1%,.4)}`. I don't know where it comes from, and it's higlighting q-items in unwanted ways.
.q-item:focus {
  background: $ist-blue;
}

.q-item.active,
.q-item.router-link-active {
  border: 3px solid $ist-blue-x-light;
  background: $ist-blue-dark;
  .mini-badge {
    background-color: $ist-blue;
  }
  .q-chip {
    background: $ist-blue;
  }
}

.navbar-link,
.navbar-link:visited,
.navbar-link:active {
  text-decoration: none;
  color: white;
  height: 85px;
  outline: none;
}

.navbar-link:hover {
  background: $ist-blue-dark !important;
}

.q-item-side {
  min-width: 20px;
}

.q-item-label {
  color: white;
}

.stateless {
  background: none !important;
}

// Todo replace with q-badge from quasar 1.0
.mini-badge {
  background-color: $ist-blue-dark;
  border-radius: 50%;
  line-height: 1;
  min-width: 25px;
  padding: 4px 4px;
  position: absolute;
  margin-left: 30px;
  top: 20px;
  font-size: 15px;
}

.menu-header {
  padding-top: 85px;
}
.motto img {
  max-width: 90%;
}

.motto {
  color: white;
  font-family: "Libre Franklin", sans-serif;
  font-size: 1.22em;
  display: inline;
}

.logo-only {
  width: 48px;
  left: 17px;
  top: 15px;
  position: relative !important;
}

.ist-menu-appname {
  line-height: 65pxm;
  width: 100%;
}

.menuEntry {
  flex-grow: 1;
}

.pointer {
  cursor: pointer;
}
.deep {
  border-bottom: 1px solid #fff2;
  box-shadow: inset 0px 1px 3px #0009;
  background-color: #0001;
}
.ist-menu-label {
  white-space: nowrap;
}
</style>
